import React from "react";
import JoLedger from "../accounting/JoLedger";

const RequestorJoLedger = () => (
  <JoLedger
    portalLabel="Requestor Portal"
    pageTitle="JO Ledger"
    pageDescription="Track the job orders you created and follow their request and liquidation progress."
    scope="created"
    hideCostAnalysis
    hideVouchers
    hideBilled
    hideGrossProfit
    basePath="/requestor/jo-ledger"
  />
);

export default RequestorJoLedger;
